import { render } from "./OnlineAgreement.vue?vue&type=template&id=6d3f283d&scoped=true&ts=true"
import script from "./OnlineAgreement.vue?vue&type=script&lang=ts"
export * from "./OnlineAgreement.vue?vue&type=script&lang=ts"

import "./OnlineAgreement.vue?vue&type=style&index=0&id=6d3f283d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3f283d"]])

export default __exports__